import { useCallback } from "react";
import { useSaveCategoryMutation } from "../mutations/useSaveCategory.mutation";
import { CategoryInterface } from "../../../interfaces/categoryInterface";

export const useSaveCategory = () => {
  const saveMutation = useSaveCategoryMutation();

  const handleSave = useCallback(
    (values: CategoryInterface) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
